module.exports = __webpack_public_path__ + "img/setting.41fac537.svg";